<ng-template #itemTemplate let-item>
    {{ item.firstName }}
    <ng-container *ngIf="item.lastName"> {{ item.lastName }}</ng-container>
    <ng-container *ngIf="props?.withMail && item.defaultEmail">
        - {{ item.defaultEmail }}</ng-container
    >
</ng-template>
<ng-template #selectedItemTemplate let-item>
    {{ item.firstName }}
    <ng-container *ngIf="item.lastName"> {{ item.lastName }}</ng-container>
    <ng-container *ngIf="props?.withMail && item.defaultEmail">
        - {{ item.defaultEmail }}</ng-container
    >
</ng-template>
